import { FontFamily, FontSize, FontWeight, LineHeight } from '@mui/joy/styles/types/typography';

declare module '@mui/joy/styles' {
  interface FontSizeOverrides {
    xl7: true;
    xl6: true;
    xl5: true;
    xs2: true;
    xs3: true;
  }

  interface FontWeightOverrides {
    xs3: true;
    xs2: true;
    xl2: true;
    xl3: true;
  }
}

interface ITypographyOptions {
  fontFamily?: Partial<FontFamily>;
  fontSize?: Partial<FontSize>;
  fontWeight?: Partial<FontWeight>;
  lineHeight?: Partial<LineHeight>;
}

export const Typography: ITypographyOptions = {
  fontFamily: {
    body: "'IBM Plex Sans', sans-serif",
  },
  fontSize: {
    xl7: '5rem',
    xl6: '4rem',
    xl5: '3rem',
    xl4: '2.25rem',
    xl3: '1.5rem',
    xl2: '1.25rem',
    xl: '1.125rem',
    lg: '1rem',
    md: '0.875rem',
    sm: '0.75rem',
    xs: '0.625rem',
    xs2: '0.5rem',
    xs3: '0.4375rem',
  },
  fontWeight: {
    xs3: 100,
    xs2: 200,
    xs: 300,
    sm: 400,
    md: 500,
    lg: 600,
    xl: 700,
    xl2: 800,
    xl3: 900,
  },
};
